import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const DashboardDispatchService = {
    setup: async () => axios.get(API_URL + "/despacho/dashboard/setup").then(({data}) => data).catch((err) => { throw err }),
}

export default DashboardDispatchService;